<template>
    <div class="row compactInputFormat">
        <div class="col-12 col-md-4">
            <label>{{lang('bank_sort_code')}}</label> <span>/</span>
            <label>{{lang('account_number')}}</label>
        </div>
        <div class="col-12 col-md-3">
            <np-input maxlength="6"
                    :label="lang('bank_sort_code')"
                    :no-wrapper="true"
                    @input="updateSortCode"
                    :value="sortCode">
            </np-input>
        </div>
        <div class="col-12 col-md-5">
            <np-input  maxlength="9"
                    :no-wrapper="true"
                    :label="lang('account_number')"
                    @addon-click="validateBank()"
                    @input="updateAccountNumber"
                    :value="accountNumber">
                <template #addon>
                    <span v-if="valid === true"><i class="fa fa-check"></i></span>
                    <span v-else-if="valid === false" @click="reset"><i class="fa fa-times"></i></span>
                    <span v-else>{{lang('validate')}}<i v-if="searching" class="fa fa-spinner fa-spin" style="margin-left:5px"></i> </span>
                </template>
            </np-input>
        </div>
    </div>
</template>

<script>
    import NPInput from './np-input.vue';
    import NPPreloader from './np-preloader.vue';

    export default {
        name: 'np-bank-validate',
        props: {
            accountNumber: String,
            sortCode: String
        },
        data: function() {
            return {
                searching: false,
                valid: '',
            }
        },
        methods: {
            reset: function() {
                this.valid = '';
            },
            updateSortCode: function(sortCode) {
                this.valid = '';
                this.$emit('sort-code', sortCode);
            },
            updateAccountNumber: function(accountNumber) {
                this.valid = '';
                this.$emit('account-number', accountNumber);
            },
            validateBank: function() {
                const payload = {
                    account: this.accountNumber,
                    sortcode: this.sortCode,
                }
                // const configs = {
                //     headers: {'X-Requested-With': 'XMLHttpRequest'}
                // }
                const vm = this;
                vm.searching = true;
                this.getAxiosInstance().post('/externalservices/validatebankaccount', payload)  //, configs)
                    .then(function(response) {
                        const data = response.data;
                        if (data.result == 'SUCCESS') {
                            vm.valid = true;
                            const bank_data = data.bankfinder_response;
                            vm.$emit('bank-data', bank_data);
                        } else {
                            vm.valid = false;
                        }
                        vm.searching = false;
                    })
                    .catch(error => {
                        vm.searching = false;
                    });

            }
        },
        components: {
            'np-input': NPInput,
            'np-preloader': NPPreloader
        }
    }
</script>

<style scoped>

</style>
